import * as React from 'react';
import { useMemo } from 'react';
// import cx from 'classnames';
import { observer } from 'mobx-react';
import aos from '@src/utils/aos';
// import useStore from '@src/utils/hooks/use-store';
// import FeatureStore from '@src/pages/main/components/feature/store';
import Page from '@src/components/page';
import Link from '@src/components/link';
// import SimpleSwiper from '@src/components/swiper/simple-swiper';
import BaseSwiper from '@src/components/swiper/base-swiper';

const styles = require('./index.less');

const Feature = ({ store }) => {
  store.use();
  // const store = useStore(() => new FeatureStore());

  const renderGameSwiper = useMemo(
    () => {
      return (
        <div>
          <BaseSwiper store={store.mainBaseSwiperStore}>
            {store.featureData?.map((item, index) => {
              return (
                <div className={styles.feature_slide} key={index}>
                  <div className={styles.picture_box}>
                    <img src={item} alt="" className={styles.feature_picture} />
                  </div>
                </div>
              );
            })}
          </BaseSwiper>
          <Link className={styles.button_feature_prev} onClick={event => store.slideFeature('prev', event)} />
          <Link className={styles.button_feature_next} onClick={event => store.slideFeature('next', event)} />
          <div id="swiper-pagination" className={styles.pagination} />
        </div>
      );
    },
    [store.featureData]
  );
  // const renderGameSwiper = useMemo(
  //   () => {
  //     return (
  //       <div>
  //         <SimpleSwiper params={store.featureSwiper}>
  //           {store.featureData?.map((item, index) => {
  //             return (
  //               <div className={styles.feature_slide} key={index}>
  //                 <div className={styles.picture_box}>
  //                   <img src={item} alt="" className={styles.feature_picture} />
  //                 </div>
  //               </div>
  //             );
  //           })}
  //         </SimpleSwiper>
  //         <Link className={styles.button_feature_prev} onClick={event => store.slideFeature('prev', event)} />
  //         <Link className={styles.button_feature_next} onClick={event => store.slideFeature('next', event)} />
  //         <div id="swiper-pagination" className={styles.pagination} />
  //       </div>
  //     );
  //   },
  //   [store.featureData]
  // );

  return (
    <Page className={styles.root}>
      <div className={styles.feature}>
        <div className={styles.feature_title} {...aos.FADE_DOWN()} />
        <div className={styles.feature_content} {...aos.FADE_UP()}>
          <div className={styles.feature_wrap}>{store.featureData.length && renderGameSwiper}</div>
        </div>
      </div>
    </Page>
  );
};

export default observer(Feature);
